/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Science & Lab`)
};

const es_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciencia y laboratorio`)
};

const de_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissenschaft & Labor`)
};

const nl_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetenschap & Lab`)
};

const fr_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Science et laboratoire`)
};

const it_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scienza & Laboratorio`)
};

const pt_br2_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciência e Laboratório`)
};

const pt_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciência e Laboratório`)
};

const ja_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科学・ラボ`)
};

const zh_cat_science_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科学与实验室`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_science_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_science_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_science_name", locale)
	if (locale === "en") return en_cat_science_name(inputs)
	if (locale === "es") return es_cat_science_name(inputs)
	if (locale === "de") return de_cat_science_name(inputs)
	if (locale === "nl") return nl_cat_science_name(inputs)
	if (locale === "fr") return fr_cat_science_name(inputs)
	if (locale === "it") return it_cat_science_name(inputs)
	if (locale === "pt-BR") return pt_br2_cat_science_name(inputs)
	if (locale === "pt") return pt_cat_science_name(inputs)
	if (locale === "ja") return ja_cat_science_name(inputs)
	return zh_cat_science_name(inputs)
};